module.exports = __webpack_public_path__ + "img/banner3.b1657e3c.png";